<template>
  <div class="paymentDetails">
    <div class="searchForm">
      <el-date-picker
        v-model="formTime"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="() => { dimension = '0' }"
      />
      <el-button class="search-btn" @click="pageNo = 1 , onSearch()">查询</el-button>
      <el-radio-group v-model="dimension" style="float:right;" @change="timeSlotChange">
        <el-radio-button label="1">本月</el-radio-button>
        <el-radio-button label="2">本季</el-radio-button>
        <el-radio-button label="3">半年</el-radio-button>
        <el-radio-button label="4">本年</el-radio-button>
      </el-radio-group>
    </div>
    <div class="showMoney">
      <span>
        待付款金额：
        <span class="show_box">
          ￥<span class="moneyStatus">{{ showData.FWaitPayAmount }}</span>
        </span>
      </span>
      <span>
        已付款：
        <span class="show_box">
          ￥<span class="moneyStatus">{{ showData.FRepayTotalAmount }}</span>
        </span>
      </span>
      <span>
        付款状态：
        <span v-if="showData.FOverdue === 1" style="color:#EC212D;font-weight: bold;">
          逾期
        </span>
        <span v-if="showData.FOverdue === 0" style="color:#5BD372;font-weight: bold;">
          未逾期
        </span>
      </span>
      <el-button class="export-btn" @click="exportExcel">导出Excel</el-button>
    </div>
    <div class="formTable">
      <el-table
        ref="singleTable"
        v-loading="loading"
        :data="tableData"
        highlight-current-row
        border
        fit
        style="width: 100%"
        height="450"
        :header-cell-style="{background:'#EC212D',color:'#fff',fontSize:'16px',fontWeight:'500',textAlign: 'center'}"
        :cell-style="{ textAlign: 'center',height:'66px',background:'#fff' }"
      >
        <el-table-column
          type="index"
          label="序号"
          width="60"
          show-overflow-tooltip
        />
        <el-table-column
          property="FOrderNo"
          label="订单编号"
          show-overflow-tooltip
        />
        <el-table-column
          property="FRepayNo"
          label="付款单号"
          show-overflow-tooltip
        />
        <el-table-column
          property="FPayName"
          label="付款方式"
          show-overflow-tooltip
        />
        <el-table-column
          property="FRepayAmount"
          label="付款金额"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span style="color:#EC212D;font-weight: bold;">
              ￥{{ scope.row.FRepayAmount }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          property="FRepayDate"
          label="付款日期"
          show-overflow-tooltip
        />
        <el-table-column
          property="FRepayPerson"
          label="付款人"
          show-overflow-tooltip
        />
      </el-table>
      <el-pagination
        style="text-align: right;margin-top:20px;"
        background
        layout="total , sizes, prev, pager, next , jumper"
        :page-sizes="[50, 100, 500]"
        :current-page.sync="pageNo"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="onSearch"
      />
    </div>
    <vagueRadio
      ref="depart"
      title="所属部门"
      :is-check-box="true"
      id-property="FDepartId"
      name-property="FDepartName"
      :search-visible="searchVisible"
      search-url="/mall/mallmanage/billapprovalinfo/getDepartInfo"
      key-word-name="keyword"
      @cfmSearch="cfmSearch"
      @closeSearch="selectDeparment"
    />
  </div>
</template>

<script>
import request from '@/utils/request'
import vagueRadio from '@/components/vagueRadio/vagueRaiod.vue'
export default {
  components: {
    vagueRadio
  },
  data() {
    return {
      showData: {
        FRepayTotalAmount: '',
        FWaitPayAmount: '',
        FOverdue: ''
      },
      dimension: '0',
      loading: false,
      searchVisible: false,
      formTime: [],
      formData: {
        FBeginOrderDate: '',
        FEndOrderDate: ''
      },
      options: [
        {
          value: -1,
          label: '全部'
        },
        {
          value: 1,
          label: '待接单'
        },
        {
          value: 4,
          label: '待收货'
        },
        {
          value: 0,
          label: '已退货'
        },
        {
          value: 5,
          label: '已完成'
        }
      ],
      pageNo: 1,
      pageSize: 50,
      total: 0,
      tableData: [],
      excelLoading: null
    }
  },
  created() {
    this.onSearch()
  },
  methods: {
    timeSlotChange(val) {
      let startTime, endTime
      const now = new Date() // 当前日期
      var nowDayOfWeek = now.getDay() // 今天本周的第几天
      var nowDay = now.getDate() // 当前日
      const nowMonth = now.getMonth() // 当前月
      const nowYear = now.getFullYear() // 当前年
      const jd = Math.ceil((nowMonth + 1) / 3)
      switch (val) {
        case '3':
          startTime = this.halfAYearAgo()
          endTime = this.formatDate(now)
          break
        case '1':
          startTime = new Date(nowYear, nowMonth, 1)
          endTime = new Date(nowYear, nowMonth + 1, 0)
          break
        case '2':
          startTime = new Date(nowYear, (jd - 1) * 3, 1)
          endTime = new Date(nowYear, jd * 3, 0)
          break
        case '4':
          startTime = new Date(nowYear, 0, 1)
          endTime = new Date(nowYear, 11, 31)
          break
      }
      if (val === '3') {
        this.formTime = [startTime, endTime]
      } else {
        this.formTime = [this.formatDate(startTime), this.formatDate(endTime)]
      }
      this.formData.FBeginOrderDate = this.formTime[0]
      this.formData.FEndOrderDate = this.formTime[1]
    },
    halfAYearAgo() {
      // 获取半年前时间
      const curDate = (new Date()).getTime()
      // 将半年的时间单位换算成毫秒
      const halfYear = 365 / 2 * 24 * 3600 * 1000
      const pastResult = curDate - halfYear // 半年前的时间（毫秒单位）
      // 日期函数，定义起点为半年前
      const pastDate = new Date(pastResult)
      const pastYear = pastDate.getFullYear()
      const pastMonth = pastDate.getMonth() + 1
      const pastDay = pastDate.getDate()
      const time = pastYear + '-' + pastMonth + '-' + pastDay
      return time
    },
    formatDate(d) {
      var date = new Date(d)
      var YY = date.getFullYear() + '-'
      var MM =
     (date.getMonth() + 1 < 10
       ? '0' + (date.getMonth() + 1)
       : date.getMonth() + 1) + '-'
      var DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      //   var hh =
      //  (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      //   var mm =
      //  (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
      //  ':'
      //   var ss =
      //  date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return YY + MM + DD
    //   + ' ' + hh + mm + ss
    },
    exportExcel() {
      this.excelLoading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = new URLSearchParams()
      params.append('jsonobj', JSON.stringify(this.getFormData()))
      request({
        url: '/mall/demand/userCenter/excel/export/demandDetailBill',
        method: 'post',
        params,
        responseType: 'blob'
      })
        .then(res => {
          if (!res.data.size) {
            this.excelLoading.close()
            this.$message.warning('没有可导出的数据')
            return
          }
          const content = res.data // 文件流
          const blob = new Blob([content], { type: 'application/vdn.ms-excel' })
          const contentDisposition = res.headers['content-disposition']
          const fileName = decodeURI(contentDisposition.split('=')[1])
          if ('download' in document.createElement('a')) { // 非IE下载
            const link = document.createElement('a')
            const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=utf-8' })
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            link.setAttribute('download', `${fileName}`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            this.excelLoading.close()
          } else { // IE10+下载
            navigator.msSaveBlob(blob, fileName)
            this.excelLoading.close()
          }
        })
        .catch(() => {
          this.excelLoading.close()
        })
    },
    getFormData() {
      const jsonobj = JSON.parse(JSON.stringify(this.formData))
      if (this.formTime !== null && this.formTime.length) {
        jsonobj.FBeginOrderDate = this.formTime[0]
        jsonobj.FEndOrderDate = this.formTime[1]
      }
      return jsonobj
    },
    getSumBill() {
      const params = new URLSearchParams()
      params.append('jsonobj', JSON.stringify(this.getFormData()))
      request({
        url: '/mall/demand/userCenter/sumpaymentDetail',
        method: 'post',
        params
      })
        .then(res => {
          if (res.data) {
            this.showData = res.data
          }
        })
    },
    onSearch() {
      this.loading = true
      this.getSumBill()
      const params = new URLSearchParams()
      params.append('pageNo', this.pageNo)
      params.append('pageSize', this.pageSize)
      params.append('jsonobj', JSON.stringify(this.getFormData()))
      request({
        url: '/mall/demand/userCenter/paymentDetail',
        method: 'post',
        params
      })
        .then(res => {
          this.tableData = res.data.records
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    cfmSearch(val, arr) {
      const codes = []
      const names = []
      arr.forEach(t => {
        codes.push(t.FTreeCode)
        names.push(t.FDepartName)
      })
      this.formData.FTreeCode = codes.toString()
      this.formData.FDepartName = names.toString()
      this.searchVisible = false
    },
    clearDepart() {
      this.formData.FTreeCode = this.formData.FDepartName = ''
    },
    selectDeparment(val) {
      this.searchVisible = val
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.onSearch()
    }
  }
}
</script>

<style lang="scss">
.paymentDetails {
    .showMoney {
        height: 68px;
        line-height: 68px;
        font-size: 16px;
        color: #666666;
        font-weight: 500;
        .show_box {
            display: inline-block;
            min-width: 100px;
            color: #EC212D;
            font-weight: bold;
        }
        .moneyStatus {
            font-size: 22px;
        }
        .export-btn {
            height: 40px;
            margin-top: 14px;
            background: #EC212D;
            color: #fff;
            float: right;
            width: 97px;
        }
    }
    .searchForm {
        .search-btn {
            width: 72px;
            height: 40px;
            background: #EC212D;
            color: #fff;
            margin-left: 32px;
        }
        .screen-btn {
            width: 124px;
            height: 41px;
            background: #F5F5F5;
            color: #666666;
            margin-left: 32px;
        }
    }

}
</style>
